import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectParserInfo,
  selectParsedObjects,
  selectSaltoObjectTypes,
} from '../../../reducers/global/parserReducer';
import {
  selectTransientObjects,
  setObjects,
} from '../../../reducers/documentation/documentationReducer';

export const useInitializeObjectsStructure = ({
  crmOrgId,
  funnelsData,
  recordTypesData,
}: {
  crmOrgId: string;
  funnelsData?: FunnelsData;
  recordTypesData?: RecordTypesData;
}) => {
  const dispatch = useDispatch();
  const pills = useSelector(selectParserInfo(crmOrgId))?.pills;
  const transientObjects = useSelector(selectTransientObjects(crmOrgId));
  const parsedObjects = useSelector(selectParsedObjects(crmOrgId));
  const objectTypes = useSelector(selectSaltoObjectTypes(crmOrgId));

  useEffect(() => {
    dispatch(
      setObjects({
        funnelsData: funnelsData ?? {},
        recordTypesData: recordTypesData ?? {},
        objectTypeNames: objectTypes ?? [],
        transientObjects,
        pills,
        parsedObjects,
      }),
    );
  }, [funnelsData, recordTypesData, objectTypes, dispatch, pills, transientObjects, parsedObjects]);
};
